import { RewardsDepositFormData, RewardsWithdrawFormData } from '../types'
import { formatAmount } from './utils'

interface PrepareWithdrawReviewDataOptions {
  isRemoveAllocation?: boolean
  blockedBalance?: string
}

export const prepareWithdrawReviewData = (
  data: RewardsWithdrawFormData,
  selectedCurrency: string,
  options?: PrepareWithdrawReviewDataOptions
) => {
  const { isRemoveAllocation = false, blockedBalance = '0.00' } = options || {}

  if (isRemoveAllocation) {
    const amountToRemove = Number.parseFloat(data.amount)
    const blocked = Number.parseFloat(blockedBalance)
    const remaining = blocked - amountToRemove

    return [
      {
        label: 'rewards.removeAllocation.amountToRemove',
        value: `${formatAmount(amountToRemove)} ${selectedCurrency}`,
      },
      {
        label: 'rewards.removeAllocation.sendBackToWallet',
        value: data.withdrawToWallet?.name || '',
      },
      {
        label: 'rewards.removeAllocation.amountRemainingAfterRemoval',
        value: `${formatAmount(Math.max(0, remaining))} ${selectedCurrency}`,
      },
    ]
  }

  return [
    {
      label: 'amount',
      value: `${formatAmount(Number.parseFloat(data.amount))} ${selectedCurrency}`,
    },
    {
      label: 'rewards.withdraw.withdrawToWallet',
      value: data.withdrawToWallet?.name || '',
    },
  ]
}

export const prepareDepositReviewData = (
  data: RewardsDepositFormData,
  selectedCurrency: string
) => {
  return [
    {
      label: 'rewards.deposit.depositFromWallet',
      value: data.allocateFrom?.name || '',
    },
    {
      label: 'amount',
      value: `${formatAmount(Number.parseFloat(data.amount))} ${selectedCurrency}`,
    },
  ]
}
